/**
 * Normalize mouse events and touch events for non-React handler events.
 * Specifically added to get coordinates from window handlers.
 */
export const getEventPosition = ({ touches, pageX, pageY }) => {
    if (touches) {
        return {
            pageX: touches[0].pageX,
            pageY: touches[0].pageY,
        };
    }

    return { pageX, pageY };
};
